import { Card } from "@workspace/web-ui/components/card";
import lockIcon from "~/assets/icons/lock.svg";
import UpdatePasswordForm from "../components/update-form";
import { useSearch } from "@tanstack/react-router";
import { Image } from "@workspace/web-ui/components/image";
// INSERT_YOUR_REWRITE_HERE
export function UpdatePasswordPage() {
  const { token } = useSearch({
    from: "/(auth)/_auth/update-password",
  });

  return (
    <Card className="max-w-[550px] flex flex-col gap-6 w-full p-[32px] rounded-[10px] shadow-lg mb-10">
      <div className="flex flex-col gap-3">
        <h1 className="text-3xl font-medium break-words text-center">Update Password</h1>
        <p className="text-base font-normal text-gray-500 break-words text-center">Welcome! You&apos;re using a temporary password. For security reasons, please change it now to ensure your account remains secure.</p>
      </div>
      <UpdatePasswordForm token={token} />

      <div className="flex items-center justify-center gap-2">
        <Image src={lockIcon} alt="Lock" layout="constrained" width={96} height={96} />
        <p>Secure Connection Established</p>
      </div>
    </Card>
  );
}
